import React, {useEffect} from 'react'
import './about.css'
import KOLAPO from '../../assets/kolapo.jpeg'
import {IoIosCodeWorking} from 'react-icons/io'
import {FiUsers} from 'react-icons/fi'
import { VscFolderActive} from 'react-icons/vsc'
import AOS from 'aos'
import 'aos/dist/aos.css'
const About = () => {
  useEffect(() => {
    AOS.init()
  })
  return (
    <section id='about'>
     <h5 data-aos="fade-up">Get To Know</h5>
     <h2 data-aos="fade-up">About Me</h2>
      <div className="container about__container">
        <div className="about__me" data-aos="zoom-in">
          <div className="about__me-image">
            <img src={KOLAPO} alt='' />
          </div>

        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className='about__card' data-aos="fade-up" >
              <IoIosCodeWorking className='about__icon' />
              <h5>Experience</h5>
              <small>4+ Years Working Experience</small>

            </article>
            <article className='about__card'  data-aos="fade-up" >
              <FiUsers className='about__icon' />
              <h5>Clients</h5>
              <small>10+ Nationwide</small>

            </article>
            <article className='about__card'  data-aos="fade-up" >
              <VscFolderActive className='about__icon' />
              <h5>Projects</h5>
              <small>30+ Projects Completed </small>

            </article>
          </div>
          <p data-aos="fade-up">
          Experienced Full Stack Developer with a passion for creating innovative webapplications. Adept at both frontend and backend development, I amcommitted to delivering high-quality solutions that meet client needs and driveuser engagement.
          </p>
          <a href='#contact' className='btn btn-primary' data-aos="fade-up">Let's Talk</a>

        </div>
      </div>

    </section>
  )
}

export default About